<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-movies__movies}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.cartoonCode" placeholder="资源ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.cartoonName" placeholder="影视名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dictCode1" placeholder="请选择分类" clearable filterable @change="getpSonDict($event)">
            <el-option
              v-for="item in pDict"
              :key="item.dictCode"
              :label="item.dictName"
              :value="item.dictCode">
            </el-option>
          </el-select>
          &nbsp
          <el-select v-model="dictCode2" clearable placeholder="请选择子分类" filterable @change="selectpSonDict($event)">
            <el-option v-for="item in pSonDict" :label="item.dictName" :key="item.dictCode" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.isFeatured" placeholder="是否精选" clearable>
            <el-option label="否" :value="0"></el-option>
            <el-option label="是" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('movies:movies:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button v-if="$hasPermission('movies:movies:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="deleteFrontSearchCacheHandle()">删除用户端缓存</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="cartoonCode" label="资源id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="cartoonName" label="资源标题" header-align="center" align="center"></el-table-column>
        <el-table-column prop="cartoonIntroduce" label="电影摘要" show-overflow-tooltip header-align="center" align="center"></el-table-column>
        <el-table-column prop="cartoonVip" label="收费类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.cartoonVip == 0" type="success">免费</el-tag>
            <el-tag v-if="scope.row.cartoonVip == 1" type="success">收费</el-tag>
        </template>
        </el-table-column>
        <el-table-column prop="isFeatured" label="是否精选" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isFeatured == 0" type="success">否</el-tag>
            <el-tag v-if="scope.row.isFeatured == 1" type="success">是</el-tag>
        </template>
        </el-table-column>
        <el-table-column prop="cartoonImage" label="资源详情图" header-align="center" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.cartoonImage" width="100" height="40" alt=""/>
          </template>
        </el-table-column>
        <el-table-column prop="moviesPrice" label="全集价钱(金币)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="onePrice" label="单集价钱(金币)" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="dictName" label="影视分类" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sonDictName" label="影视子类" header-align="center" align="center"></el-table-column>
        <el-table-column prop="cartoonHot" label="热度" header-align="center" align="center"></el-table-column>
        <el-table-column prop="channel" label="采集渠道" header-align="center" align="center"></el-table-column>
        <el-table-column prop="cartoonScore" label="评分" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="InfoHandle(scope.row.cartoonCode)">查看分集</el-button>
            <el-button v-if="$hasPermission('movies:movies:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.cartoonCode)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('movies:movies:delete')" type="text" size="small" @click="deleteHandle(scope.row.cartoonCode)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
    
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module-movel'
import AddOrUpdate from './movies-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/movies/movies/page',
        getDataListIsPage: true,
        exportURL: '/movies/movies/export',
        deleteURL: '/movies/movies',
        deleteIsBatch: true,
        deleteIsBatchKey: 'cartoonCode'
      },
      InfoVisible: false,
      type:'0',
      pDict:[],
      pSonDict:[],
      dataForm: {
        cartoonCode: '',
        cartoonName: '',
        dictCode: '',
        sonDictCode: '',
        isFeatured: ''
      },
      dictCode1:'',
      dictCode2:''
    }
  },
  components: {
    AddOrUpdate
  },
  created(){
    this.getpDict()
  },
  methods: {
    InfoHandle(id){
      // this.$router.push({name: "moviesinfo-moviesinfo",params:{cartoonCode:id}});
     
      this.$router.push({path:'moviesinfo-moviesinfo',query:{cartoonCode:id}})
    },
    getpDict() {
      this.$http.get(`/sondict/sondict/getpDict/${this.type}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.pDict = res.data
      }).catch(() => {})
    },
    getpSonDict(val) {//根据设备组id获取相应的商品
      this.dataForm.dictCode = this.dictCode1
      this.type = this.dictCode1?this.dictCode1:'0'
      this.$http.get(`/sondict/sondict/getpSonDict/${this.type}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.pSonDict = res.data
      }).catch(() => {})
    },
    selectpSonDict(val){
      this.dataForm.sonDictCode = this.dictCode2
    },
    deleteFrontSearchCacheHandle() {
      this.$confirm('确定要删除用户端缓存吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete('/movies/movies/deleteFrontSearchCache').then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message.success('用户端缓存删除成功')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>
